import React from 'react'
import HoldDownQuantity from '../../shared/pu-react/components/pallets/HoldDownQuantity';
import NeedTopHat from '../../shared/pu-react/components/pallets/NeedTopHat';
import NeedStiffenerBar from '../../shared/pu-react/components/pallets/NeedStiffenerBar';
import ThroughHoleQuantity from '../../shared/pu-react/components/pallets/ThroughHoleQuantity';
import {
  holdDownQuantity as holdDownQuantityTooltip,
  needTopHat as needTopHatTooltip,
  needStiffenerBar as needStiffenerBarTooltip,
  shoulderBolts as shoulderBoltsTooltip,
} from '../data/Tooltips';

const Hardware = (props) => {
  const {validator, parameters} = props
  return (
    <div className="hardware-section">
      <h5 className="hardware-title">Hardware</h5>
      <div className="row">
        <div className="col-12">
          <HoldDownQuantity {...props} tooltip={holdDownQuantityTooltip} label="# of Hold Downs ($3 each)">
            {validator.message(`Hold Down Quantity`, parameters.hold_down_board_quantity, 'required|integer|min:0,num')}
          </HoldDownQuantity>
        </div>
        <div className="col-12">
          <NeedTopHat {...props} tooltip={needTopHatTooltip}>
            {validator.message(`Need Top Hat`, parameters.pallet_need_top_hat, 'required')}
          </NeedTopHat>
        </div>
        <div className="col-12">
          <NeedStiffenerBar {...props} tooltip={needStiffenerBarTooltip}>
            {validator.message(`Need Stiffener Bars`, parameters.pallet_need_stiffener_bar, 'required')}
          </NeedStiffenerBar>
        </div>
        <div className="col-12">
          <ThroughHoleQuantity {...props} tooltip={shoulderBoltsTooltip} label="How many through-hole components need to be pressed down with shoulder bolts? ($2 each)">
            {validator.message(`Through-Hole quantity`, parameters.through_hole_component_pressed_quantity, 'required|integer|min:0,num')}
          </ThroughHoleQuantity>
        </div>
      </div>
    </div>
  )
}

export default Hardware;
